// extracted by mini-css-extract-plugin
export default {"tableCard":"TableQuestionCard_tableCard__XhvJd","editableCardTable":"TableQuestionCard_editableCardTable__Y6m9W","tableCardButtons":"TableQuestionCard_tableCardButtons__H76n2"};